import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { staticComponentValueConverter } from '../StaticComponentValues';
import { ChildComponents } from '../../DnDChildComponents';

const MenuList_8 = ({ item }) => {
  const staticValues = useSelector(state => state.themeSlice?.staticValues);
  const customization = staticComponentValueConverter(item?.customization);

  const [selectedTopId, setSelectedTopId] = useState(null);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);

  const getLevelStyles = level => {
    switch (level + 1) {
      case 1:
        return {
          textSize: customization?.levelOneTextSize,
          textColor: customization?.levelOneTextColor,
          textWeight: customization?.levelOneTextWeight,
        };
      case 2:
        return {
          textSize: customization?.levelTwoTextSize,
          textColor: customization?.levelTwoTextColor,
          textWeight: customization?.levelTwoTextWeight,
        };
      case 3:
        return {
          textSize: customization?.levelThreeTextSize,
          textColor: customization?.levelThreeTextColor,
          textWeight: customization?.levelThreeTextWeight,
        };
      default:
        return {
          textSize: customization?.levelFourAndOthersTextSize,
          textColor: customization?.levelFourAndOthersTextColor,
          textWeight: customization?.levelFourAndOthersTextWeight,
        };
    }
  };

  useEffect(() => {
    if (customization?.items?.length > 0) {
      const firstTop = customization.items[0];
      setSelectedTopId(firstTop.id);
      const firstChild = firstTop.children?.[0];
      if (firstChild) {
        setSelectedCategoryId(firstChild.categoryId);
      }
    }
  }, []);

  return customization?.items?.length > 0 ? (
    <div
      style={{
        margin: customization?.containerPadding,
        backgroundColor: customization?.backgroundType === 'backgroundColor' ? customization?.backgroundColor : '',
        backgroundImage:
          customization?.backgroundType === 'backgroundImage' ? `url(${customization?.backgroundImage})` : '',
        borderRadius: customization?.borderRadius,
        boxShadow: ChildComponents[customization?.boxShadow]?.data,
        overflow: 'hidden',
      }}
    >
      {/* Üst başlıklar */}
      <div style={{ display: 'flex', gap: 10, padding: '10px' }}>
        {customization.items.map(group => (
          <div
            key={group.id}
            onClick={() => {
              setSelectedTopId(group.id);
              // categoryId burada sıfırlanmaz, sadece üst başlık değişir
            }}
            style={{
              cursor: 'pointer',
              padding: '5px 10px',
              borderRadius: '8px',
              backgroundColor: selectedTopId === group.id ? '#ddd' : '#f7f7f7',
              fontWeight: 'bold',
            }}
          >
            {group.title}
          </div>
        ))}
      </div>

      {/* Alt başlıklar */}
      <div style={{ padding: '0 10px 10px 10px' }}>
        {customization.items
          .find(group => group.id === selectedTopId)
          ?.children.map((child, idx) => (
            <div
              key={idx}
              onClick={() => setSelectedCategoryId(child.categoryId)}
              style={{
                padding: customization?.padding,
                fontSize: getLevelStyles(1)?.textSize,
                fontWeight: getLevelStyles(1)?.textWeight,
                color: getLevelStyles(1)?.textColor,
                cursor: 'pointer',
                backgroundColor: selectedCategoryId === child.categoryId ? '#e0e0e0' : 'transparent',
                borderRadius: '5px',
              }}
            >
              {child.title}
            </div>
          ))}
      </div>

      {/* Seçilen categoryId gösterimi */}
      {selectedCategoryId && (
        <div style={{ padding: '10px', fontStyle: 'italic', color: '#555' }}>
          Seçilen Category ID: <b>{selectedCategoryId}</b>
        </div>
      )}
    </div>
  ) : (
    <img src={item?.placeholderImage} className="w-full" />
  );
};

export default MenuList_8;
